
import React, { Fragment, useEffect } from 'react';
import { useContext } from 'react';
import { Bell, Maximize } from 'react-feather';
import { UL, LI, } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';
import Bookmarks from './Bookmark';
import LanguageClass from './Language';
import LogoutClass from './Logout';
import MessageDrop from './MessageDrop';
import MoonLight from './MoonLight';
import Notifications from './Notifiations';
import { Col } from 'reactstrap';
import SubscriptionDetails from './SubscriptionDetail';
import { useDispatch, useSelector } from 'react-redux';
import EmailVerification from './EmailVer';
import { NavLink } from 'react-router-dom';
import { use } from 'react';
import { getNotificationCount, getNotificationCountRole } from '../../../CommonUrl';
import { setNotificationCount } from '../../../Redux/NotificationReducer';
import { getClientUrlDataToken } from '../../../Utils/restUtils';

const Rightbar = () => {
    const { sidebarResponsive } = useContext(CustomizerContext);
    const authState = useSelector((state) => state.auth);
    const notificationSate = useSelector((state) => state?.notification);
    const dispatch = useDispatch()

    //full screen function
    function goFull() {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    
    const notificationCount = async () => {
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getNotificationCount :
            getNotificationCountRole)
        dispatch(setNotificationCount(response?.data))

    };

    useEffect(() => {
        notificationCount()
    }, [])

    return (
        <Fragment>
            <Col className="nav-right  pull-right right-header p-0">
                <UL attrUL={{ className: `simple-list d-flex flex-row nav-menus ${sidebarResponsive ? 'open' : ''}` }} >
                    {/* <LI attrLI={{ className: 'language-nav' }}>                        
                        <LanguageClass/>                        
                    </LI> */}
                    {/* <MoonLight /> */}
                    {/* <Bookmarks /> */}
                    {/* <Notifications /> */}
                    {/* <MessageDrop /> */}
                    {/* {authState.subStatus?.email_verified === 'no' &&
                        <EmailVerification />
                    } */}
                    <div className={notificationSate?.notificationCount === 0 ? "px-2" : "notification-box px-2"}>
                        <NavLink to={'/view-notifications'}>

                            <Bell />
                            <span className="badge rounded-pill badge-primary">{notificationSate?.notificationCount > 99
                                ? "99+" : notificationSate?.notificationCount !== 0 && notificationSate?.notificationCount}</span>
                        </NavLink>
                    </div>
                    {authState.userRole === 1 &&
                        <SubscriptionDetails />
                    }
                    <LI attrLI={{ className: 'maximize' }}>
                        <a className="text-dark" href="#javascript" onClick={goFull}>
                            <Maximize />
                        </a>
                    </LI>
                    <LogoutClass />
                </UL>
            </Col>
        </Fragment >
    );
};

export default Rightbar;